import cashapp_merchant_deposit from './cashapp_merchant_deposit';
import applepay_merchant_deposit from './applepay_merchant_deposit';
import paypal_merchant_deposit from './paypal_merchant_deposit';
import googlepay_merchant_deposit from './googlepay_merchant_deposit';
import cashapp_deposit from './cashapp_deposit';
import cashapp_p2p_rent from './cashapp_p2p_rent';
import crypto from './crypto';
import card_deposit from './card_deposit';
import bitcoin_deposit from './crypto';
import chime_deposit from './chime_deposit';
import zelle_deposit from './zelle_deposit';

export default {
    cashapp_merchant_deposit,
    applepay_merchant_deposit,
    paypal_merchant_deposit,
    googlepay_merchant_deposit,
    cashapp_deposit,
    cashapp_p2p_rent,
    crypto,
    card_deposit,
    bitcoin_deposit,
    chime_deposit,
    zelle_deposit
}